// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3HV3U","modalForm":"UpgradeEpcsModal_modalForm__2xKEi","modalFooter":"UpgradeEpcsModal_modalFooter__1OQm_"};